import { AnalyticsV2Event } from '../../events';

import { loadProtobuf } from './lazyExports';
import { logProtobufEvents } from './logProtobufEvents';

type GetProtobufEventRequestBody = (analyticsEvents: AnalyticsV2Event[]) => Promise<string>;
export const getProtobufEventRequestBody: GetProtobufEventRequestBody = async (analyticsEvents) => {
  const { events, base64 } = await loadProtobuf();
  const { decode, encode, length } = base64;

  const protobufEvents = analyticsEvents.map(({ properties: { value, typeUrl, ...commonProps } }) => {
    const arrayLength = length(value);
    const buffer = new Uint8Array(arrayLength);
    const { clientId, ecsEtag, eventId, timestamp, userAgent, userId, networkId, webClientType } = commonProps;
    decode(value, buffer, 0);

    return {
      clientId,
      ecsEtag,
      eventId,
      networkId,
      timestamp,
      userAgent,
      userId,
      webClientType,
      properties: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        type_url: typeUrl,
        value: buffer,
      },
    };
  });

  logProtobufEvents(protobufEvents);

  const encoded = events.EventsWrapperV1.encode({ events: protobufEvents }).finish();

  return encode(encoded, 0, encoded.length);
};
